import { Star } from "lucide-react";
import { useSeo } from "@/hooks/useSeo";
import { PageHero, CTABand } from "@/components/Layout";
import { TestimonialGrid } from "@/components/Sections";
import { business, testimonials } from "@/data/site";

const Reviews = () => {
  useSeo({
    title: `Reviews & Testimonials — ${business.name} New York`,
    description: "Read real 5-star reviews from New York homeowners who trust us for plumbing, electrical, and HVAC service. See why neighbors recommend us.",
  });

  return (
    <>
      <PageHero eyebrow="Testimonials" title="What New Yorkers Say About Us" subtitle="We've earned 500+ five-star reviews the honest way — through great work and great service." />

      <section className="bg-white border-b border-[#E2E8F0]" data-testid="reviews-summary">
        <div className="max-w-7xl mx-auto px-4 py-10 grid grid-cols-2 sm:grid-cols-4 gap-6 text-center">
          {[{ n: "4.9", l: "Average Rating" }, { n: "500+", l: "Reviews" }, { n: "98%", l: "Would Recommend" }, { n: `${business.yearsInBusiness}+`, l: "Years Trusted" }].map((s) => (
            <div key={s.l}>
              <div className="flex justify-center gap-0.5 mb-2">{Array.from({ length: 5 }).map((_, i) => <Star key={i} className="w-4 h-4 fill-[#EAB308] text-[#EAB308]" />)}</div>
              <div className="font-display font-black text-3xl text-[#0F2E4C]">{s.n}</div>
              <div className="text-sm text-[#475569] uppercase tracking-wide">{s.l}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 py-16 sm:py-24" data-testid="reviews-grid">
        <TestimonialGrid />
        <p className="text-xs text-[#475569] text-center mt-8 italic">Sample testimonials shown for demonstration. Replace with the client's real, verified reviews before launch.</p>
      </section>

      <CTABand heading="Join Hundreds of Happy Neighbors" />
    </>
  );
};

export default Reviews;
